    <template>

    <div class="h-screen flex overflow-hidden">
        <transition
            enter-active-class="transition ease-in-out duration-300 transform"
            enter-from-class="-translate-x-full"
            enter-to-class="translate-x-0"
            leave-active-class="transition ease-in-out duration-300 transform"
            leave-from-class="translate-x-0"
            leave-to-class="-translate-x-full"
        >
            <div class="fixed inset-0 flex z-40 md:hidden" role="dialog" aria-modal="true" v-show="sideBarOpen">

                <div class="fixed inset-0 bg-gray-600 bg-opacity-75" aria-hidden="true"></div>

                <div class="relative flex-1 flex flex-col max-w-xs w-full bg-gray-800">

                    <div class="absolute top-0 right-0 -mr-12 pt-2">
                        <button class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" @click.prevent="closeSideBar">
                            <span class="sr-only">Close sidebar</span>
                            <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div class="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
                        <router-link :to="{ name: 'dashboard' }">
                            <header class="flex lg:hidden items-center flex-shrink-0 px-4 text-brand-600" role="banner">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" preserveAspectRatio="none" class="fill-current h-10" focusable="false">
                                    <path d="M476.791 135.986L250.075 5.818 50.9 120.812l425.765 245.379V283.2l-288.49-165.674 58.07-33.522 230.546 132.357zM23.209 136.478l423.717 244.204-196.635 113.499L23.578 363.287v-77.109l228.319 131.107 58.05-33.506L23.209 219.091z"></path>
                                </svg>
                                <div class="ml-2 text-center text-white">
                                    {{ app_name }}
                                    <span v-if="tenant_name">({{tenant_name}})</span>
                                </div>
                            </header>
                        </router-link>
                        <nav class="main-side-navigation mt-5 flex-1 px-2 bg-gray-800 space-y-1" role="navigation">
                            <router-link :to="{ name: 'dashboard' }" @click.native="closeSideBar">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                                </svg>
                                Dashboard
                            </router-link>

                            <router-link :to="{ name: 'place-order' }" @click.native="closeSideBar">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable=false>
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                                </svg>
                                Place Order
                            </router-link>

                            <router-link :to="{ name: 'order.index' }" @click.native="closeSideBar">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                                Order History
                            </router-link>

                            <router-link :to="{ name: 'products' }" @click.native="closeSideBar">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                                </svg>
                                Products
                            </router-link>

                            <router-link :to="{ name: 'manage-funds' }" @click.native="closeSideBar">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                                </svg>
                                Manage Funds
                            </router-link>

                            <router-link :to="{ name: 'report' }" @click.native="closeSideBar">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
                                </svg>
                                Reports
                            </router-link>

                            <router-link :to="{ name: 'integrations' }" @click.native="closeSideBar">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                Integrations
                            </router-link>

                            <router-link :to="{ name: 'logs' }" @click.native="closeSideBar">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                                </svg>
                                Logs
                            </router-link>

                            <router-link :to="{ name: 'accounts' }" @click.native="closeSideBar" v-if="isAdmin">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                </svg>
                                Accounts
                            </router-link>

                            <router-link :to="{ name: 'payments' }" @click.native="closeSideBar" v-if="isAdmin">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 9a2 2 0 10-4 0v5a2 2 0 01-2 2h6m-6-4h4m8 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                Payments
                            </router-link>

                            <router-link :to="{ name: 'processors' }" @click.native="closeSideBar" v-if="isAdmin">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
                                </svg>
                                Processors
                            </router-link>

                            <router-link :to="{ name: 'tenants' }" @click.native="closeSideBar" v-if="isAdmin">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
                                </svg>
                                Tenants
                            </router-link>

                            <router-link :to="{ name: 'documentation' }" @click.native="closeSideBar">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                                User Guide
                            </router-link>

                            <router-link :to="{ name: 'documentation.api' }" @click.native="closeSideBar">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                                </svg>
                                API Documentation
                            </router-link>
                        </nav>
                    </div>
                    <div class="flex-shrink-0 flex bg-gray-700 p-4">

                        <router-link class="flex-shrink-0 w-full group block bg-dark" :to="{ name: 'settings' }" @click.native="closeSideBar">
                            <div class="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                <div class="flex-1 ml-3">
                                    <p class="text-sm font-medium text-white">
                                        {{ authName }}
                                    </p>
                                    <p class="text-xs font-medium text-gray-300 group-hover:text-gray-200" >
                                        {{ authAccountName }}
                                    </p>
                                </div>
                                <div class="justify-end">
                                    <a href="#" @click.prevent="logout" class="text-brand-300" aria-label="Logout">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-6" focusable="false">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </router-link>

                    </div>

                </div>

                <div class="flex-shrink-0 w-14">
                    <!-- Force sidebar to shrink to fit close icon -->
                </div>
            </div>

        </transition>

        <!-- Static sidebar for desktop -->
        <div class="hidden md:flex md:flex-shrink-0">

            <div class="flex flex-col w-64">
                <div class="flex flex-col h-0 flex-1 bg-gray-800">

                    <div class="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
                        <router-link :to="{ name: 'dashboard' }">
                            <header class="flex items-center flex-shrink-0 px-4 text-brand-600" role="banner">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" preserveAspectRatio="none" class="fill-current h-10" focusable="false">
                                    <path d="M476.791 135.986L250.075 5.818 50.9 120.812l425.765 245.379V283.2l-288.49-165.674 58.07-33.522 230.546 132.357zM23.209 136.478l423.717 244.204-196.635 113.499L23.578 363.287v-77.109l228.319 131.107 58.05-33.506L23.209 219.091z"></path>
                                </svg>
                                <div class="ml-2 text-center text-white">
                                    {{ app_name }}
                                    <span v-if="tenant_name">({{tenant_name}})</span>
                                </div>
                            </header>
                        </router-link>
                        <nav class="main-side-navigation mt-5 flex-1 px-2 bg-gray-800 space-y-1" role="navigation">
                            <router-link :to="{ name: 'dashboard' }" @click.native="closeSideBar">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                                </svg>
                                Dashboard
                            </router-link>

                            <router-link :to="{ name: 'place-order' }" @click.native="closeSideBar">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable=false>
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                                </svg>
                                Place Order
                            </router-link>

                            <router-link :to="{ name: 'order.index' }" @click.native="closeSideBar">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                                Order History
                            </router-link>

                            <router-link :to="{ name: 'products' }" @click.native="closeSideBar">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                                </svg>
                                Products
                            </router-link>

                            <router-link :to="{ name: 'manage-funds' }" @click.native="closeSideBar">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                                </svg>
                                Manage Funds
                            </router-link>

                            <router-link :to="{ name: 'report' }" @click.native="closeSideBar">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
                                </svg>
                                Reports
                            </router-link>

                            <router-link :to="{ name: 'integrations' }" @click.native="closeSideBar">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                Integrations
                            </router-link>

                            <router-link :to="{ name: 'logs' }" @click.native="closeSideBar">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                                </svg>
                                Logs
                            </router-link>

                            <router-link :to="{ name: 'accounts' }" @click.native="closeSideBar" v-if="isAdmin">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                </svg>
                                Accounts
                            </router-link>

                            <router-link :to="{ name: 'payments' }" @click.native="closeSideBar" v-if="isAdmin">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 9a2 2 0 10-4 0v5a2 2 0 01-2 2h6m-6-4h4m8 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                Payments
                            </router-link>

                            <router-link :to="{ name: 'processors' }" @click.native="closeSideBar" v-if="isAdmin">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
                                </svg>
                                Processors
                            </router-link>

                            <router-link :to="{ name: 'tenants' }" @click.native="closeSideBar" v-if="isAdmin">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                </svg>
                                Tenants
                            </router-link>

                            <router-link :to="{ name: 'documentation' }" @click.native="closeSideBar">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                                User Guide
                            </router-link>

                            <router-link :to="{ name: 'documentation.api' }" @click.native="closeSideBar">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                                </svg>
                                API Documentation
                            </router-link>
                        </nav>
                    </div>
                    <div class="flex-shrink-0 flex bg-gray-700 p-4">
                        <router-link class="flex-shrink-0 w-full group block bg-dark" :to="{ name: 'settings' }">
                            <div class="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                <div class="flex-1 ml-3">
                                    <p class="text-sm font-medium text-white">
                                        {{ authName }}
                                    </p>
                                    <p class="text-xs font-medium text-gray-300 group-hover:text-gray-200">
                                        {{ authAccountName }}
                                    </p>
                                </div>
                                <div class="justify-end">
                                    <a href="#" @click.prevent="logout" class="bg-dark" aria-label="Logout">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-6" focusable="true">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex flex-col w-0 flex-1 overflow-hidden">
            <div class="md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3">
                <button class="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500" @click.prevent="toggleSideBar">
                    <span class="sr-only">Open sidebar</span>
                    <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="false">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                </button>
            </div>
            <div class="flex-1 relative z-0 overflow-y-auto focus:outline-none">
                <div class="z-50 w-full px-8 py-4 mb-2 bg-indigo-400 text-white text-sm flex" v-if="setupIncompleteBanner">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-20 md:w-12 lg:w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                    <p class="ml-4">
                        You have not completed your account setup, before you can <span class="font-medium">place an order</span> or create an  <span class="font-medium">integration token</span> you must
                        update your address, <router-link :to="{ name: 'settings' }" class="text-white hover:text-indigo-100 underline">go to account settings</router-link>.
                    </p>
                </div>

                <div class="py-4" :class="{ 'py-2': setupIncompleteBanner }" v-if="application_loaded">
                    <div class="px-4 sm:px-6 md:px-8">
                        <div class="mt-2">
                            <router-view></router-view>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <Loading :message="application_error"></Loading>
                </div>
            </div>
            <footer class="lg:grid lg:grid-cols-2 gap-2 bg-gray-800 p-2 text-xs text-gray-400" role="contentinfo">
                <div class="hidden lg:flex lg:items-center text-gray-400">
                    Unauthorised access is not permitted.
                </div>
                <div class="flex justify-center lg:justify-end">
                    <a :href="status_uri" class="bg-dark mr-2" target="_blank" v-if="status_uri">System Status</a>
                    <router-link class="bg-dark mr-2" :to="{ name: 'terms' }">Terms of Service</router-link>
                    <router-link class="bg-dark mr-2" :to="{ name: 'privacy' }">Privacy Policy</router-link>
                    <span>Copyright &copy; <a :href="copyright.url" class="bg-dark" target="_blank">{{ copyright.name}}</a> {{ version }}</span>
                </div>
            </footer>
        </div>
    </div>


</template>

<script>
import Loading from "../Support/Loading";
import {User} from "../../app/Auth/User";

export default {
    name: "Application",
    props: {
        auth: {
            type: Object,
            required: false,
        },
        app_name: {
            type: String,
            required: false
        },
        tenant_name: {
            type: String,
            required: false
        },
        version: {
            type: String,
            required: false,
            default: '-'
        },
        status_uri: {
            type: String,
            required: false
        },
        copyright: {
            type: Object,
            required: false
        }
    },
    components: {
        Loading
    },
    data() {
        return  {
            setup_complete: false,
            show_sidebar: false,
            application_loaded: false,
            application_error: false
        }
    },
    computed: {
        authName() {
            if (this.auth) {
                return this.auth.name;
            }

            return '-';
        },
        authAccountName() {
            if (this.auth) {
                return this.auth.account_name;
            }

            return '-';
        },
        sideBarOpen() {
            return this.show_sidebar;
        },
        isAdmin() {
            if (this.auth) {
                return this.auth.role === 'admin';
            }

            return false;
        },
        setupIncompleteBanner() {
            let route = this.$route.name;

            if (this.application_loaded && this.setup_complete) {
                return false;
            }

            return this.application_loaded && !this.auth.account_setup_complete && route !== 'settings' && route !== 'invite'
        }
    },
    methods: {
        scrollToTop() {
            window.scrollTo(0,0);
        },
        closeSideBar() {
            this.show_sidebar = false;
        },
        toggleSideBar() {
            this.show_sidebar = ! this.show_sidebar;
        },
        logout() {
            let vm = this;

            new User().logout().then(r => {
                vm.$router.push({ name: 'login' });
            });
        }
    },
    mounted() {
        let vm = this;

        new Promise((resolve, reject) => {
            if (vm.auth) {
                resolve(true);
            } else {
                reject('Application could not be loaded, no authentication passed.');
            }
        }).then(result => {
            vm.application_loaded = result;
        }).catch(error => {
            vm.application_error = error;
        });
    }

}
</script>
